import { render, staticRenderFns } from "./SetModal.vue?vue&type=template&id=50074d10&scoped=true&"
import script from "./SetModal.vue?vue&type=script&lang=js&"
export * from "./SetModal.vue?vue&type=script&lang=js&"
import style0 from "./SetModal.vue?vue&type=style&index=0&id=50074d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50074d10",
  null
  
)

export default component.exports